import { format } from "date-fns";
import { Clock } from "iconsax-react";
import { Switch } from "@/view/components/ui/switch";
import { cn } from "@/app/utils/cn";

interface ConfigCardProps {
  title: string;
  items: {
    label: string;
    value: string | boolean;
    leader?: number;
    seller?: number;
    format?: (v: string) => string;
    isSwitch?: boolean;
  }[];
  updatedAt: string;
  teams?: boolean;
  isAppConfig?: boolean;
  numberOfGoals?: number;
  showSwitch?: boolean;
  switchActive?: boolean;
  variant?: "default" | "commissions";
}

export const ConfigCard = ({
  title,
  items,
  updatedAt,
  teams = false,
  numberOfGoals,
  showSwitch = false,
  switchActive = false,
  isAppConfig = false,
  variant = "default",
}: ConfigCardProps) => {
  return (
    <div className="flex min-h-[279px] min-w-[220px] w-full flex-col items-start gap-4 rounded-md border border-gray01 p-5 hover:cursor-pointer hover:border-primary hover:bg-primary/5">
      {!teams && !showSwitch && (
        <span className="text-xl font-semibold">{title}</span>
      )}
      {!teams && showSwitch && (
        <div className="flex w-full items-center justify-between">
          <span className="text-xl font-semibold">{title}</span>
          <Switch
            checked={switchActive}
            disabled={true}
            className={cn(
              "pointer-events-none data-[state=checked]:bg-green-500 data-[state=unchecked]:bg-red-500",
            )}
          />
        </div>
      )}
      {teams && (
        <div className="flex w-full items-center justify-between">
          <span className="text-xl font-semibold">{title}</span>
          {variant === "default" && numberOfGoals !== undefined && (
            <span className="text-xs text-black04">{numberOfGoals}</span>
          )}
        </div>
      )}

      <div className="mt-auto space-y-4 self-stretch overflow-hidden">
        {items?.map((item, index) => (
          <div key={index} className="flex items-center justify-between gap-3">
            <span className="whitespace-nowrap text-xs text-black04">
              {item.label}
            </span>
            <div className="h-[1px] w-full flex-1 border-t-[1px] border-solid border-gray01" />
            {item.isSwitch ? (
              <Switch
                checked={Boolean(item.value)}
                disabled={true}
                className="pointer-events-none data-[state=checked]:bg-primary"
              />
            ) : (
              <span
                className={cn(
                  "max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium",
                  isAppConfig && "overflow-hidden text-ellipsis text-base [direction:rtl]",
                )}
              >
                {variant === "default"
                  ? item.format
                    ? item.format(String(item.value))
                    : item.value
                  : variant === "commissions" &&
                      item.leader !== undefined &&
                      item.seller !== undefined
                    ? `${item.leader} / ${item.seller}`
                    : null}
              </span>
            )}
          </div>
        ))}
      </div>
      <div className="my-2 h-[1px] w-full border-b bg-border" />

      <div className="flex items-center justify-center self-center text-xs">
        <Clock size={16} />
        <span className="ml-2">Última atualização:&nbsp;</span>
        <span className="text-black04">
          {format(new Date(updatedAt), "dd/MM/yyyy")}
        </span>
      </div>
    </div>
  );
};
